import { SUPPORTED_LANGUAGES } from 'common/constant/constant';
import { SelectOptionType } from 'utils/react-table';

export enum AgeType {
    Unknown,
    Under17,
    Under18,
    Under19,
    Under20,
    Olympic,
    YouthOlympic,
    Main,
    Under13,
    Under14,
    Under15,
    Under16,
    Under21,
    Under22,
    Under23,
}
export enum TeamType {
    Unknown,
    Club,
    National,
}

export enum FootballType {
    Unknown,
    Football,
    Futsal,
    Beach,
    ESport,
}

export enum Gender {
    Unknown,
    Male,
    Female,
}

type TeamDto = {
    id: number;
    name: string;
    footballType: FootballType;
    teamType: TeamType;
    ageType: AgeType;
    gender: Gender;
    abbreviation: string;
    pictureUrl: string;
    localizedContents?: Partial<Record<SUPPORTED_LANGUAGES, TeamLocalizedContentProps>>;
};

export type TeamLocalizedContentProps = {
    name?: string;
};

export const mapTeamToSelectOption = (teams: Array<TeamDto>): Array<SelectOptionType> => {
    return teams.map((team) => ({
        value: team.id,
        label: `${team.name} - (${getLabelFootballType(team.footballType)}, ${getLabelTeamType(
            team.teamType,
        )}, ${getLabelAgeType(team.ageType)}, ${getLabelGender(team.gender)})`,
    }));
};

const getLabelAgeType = (ageType: AgeType): string => {
    switch (ageType) {
        case AgeType.Olympic:
            return 'Olympic';
        case AgeType.YouthOlympic:
            return 'Youth Olympic';
        case AgeType.Main:
            return 'Main';
        case AgeType.Under13:
            return 'U-13';
        case AgeType.Under14:
            return 'U-14';
        case AgeType.Under15:
            return 'U-15';
        case AgeType.Under16:
            return 'U-16';
        case AgeType.Under17:
            return 'U-17';
        case AgeType.Under18:
            return 'U-18';
        case AgeType.Under19:
            return 'U-19';
        case AgeType.Under20:
            return 'U-20';
        case AgeType.Under21:
            return 'U-21';
        case AgeType.Under22:
            return 'U-22';
        case AgeType.Under23:
            return 'U-23';
        case AgeType.Unknown:
        default:
            return 'Unknown';
    }
};

const getLabelFootballType = (footballType: FootballType): string => {
    switch (footballType) {
        case FootballType.Football:
            return 'Football';
        case FootballType.Futsal:
            return 'Futsal';
        case FootballType.Beach:
            return 'Beach';
        case FootballType.ESport:
            return 'ESport';
        case FootballType.Unknown:
        default:
            return 'Unknown';
    }
};

const getLabelGender = (gender: Gender): string => {
    switch (gender) {
        case Gender.Male:
            return 'Male';
        case Gender.Female:
            return 'Female';
        case Gender.Unknown:
        default:
            return 'Unknown';
    }
};

const getLabelTeamType = (teamType: TeamType): string => {
    switch (teamType) {
        case TeamType.Club:
            return 'Club';
        case TeamType.National:
            return 'National';
        default:
            return 'Unknown';
    }
};

export const AgeTypeOptions = [
    { label: 'Olympic', value: AgeType.Olympic },
    { label: 'Youth Olympic', value: AgeType.YouthOlympic },
    { label: 'Main', value: AgeType.Main },
    { label: 'U-13', value: AgeType.Under13 },
    { label: 'U-14', value: AgeType.Under14 },
    { label: 'U-15', value: AgeType.Under15 },
    { label: 'U-16', value: AgeType.Under16 },
    { label: 'U-17', value: AgeType.Under17 },
    { label: 'U-18', value: AgeType.Under18 },
    { label: 'U-19', value: AgeType.Under19 },
    { label: 'U-20', value: AgeType.Under20 },
    { label: 'U-21', value: AgeType.Under21 },
    { label: 'U-22', value: AgeType.Under22 },
    { label: 'U-23', value: AgeType.Under23 },
];

export const GenderOptions = [
    { label: 'Male', value: Gender.Male },
    { label: 'Female', value: Gender.Female },
];

export const FootballTypeOptions = [
    { label: 'Beach', value: FootballType.Beach },
    { label: 'ESport', value: FootballType.ESport },
    { label: 'Football', value: FootballType.Football },
    { label: 'Futsal', value: FootballType.Futsal },
];

export const TeamTypeOptions = [
    { label: 'Club', value: TeamType.Club },
    { label: 'National', value: TeamType.National },
];

export default TeamDto;
